import { NgModule } from '@angular/core';
import { DomainEffect } from '@engagement/core/store/domain/domain.effect';
import { EngagementSystemEffect } from '@engagement/core/store/system/engagement-system.effect';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { fromEngagement } from '@root-store/index';

@NgModule({
  imports: [
    // declare store reducers
    StoreModule.forFeature(fromEngagement.featureName, fromEngagement.reducers, {
      initialState: fromEngagement.initialState,
      metaReducers: fromEngagement.metaReducers,
    }),
    // declare store effects
    EffectsModule.forFeature([DomainEffect, EngagementSystemEffect]),
  ],
})
export class EngagementStoreModule {}
